import React from 'react';
import PropTypes from 'prop-types';

import { t } from '../../../../modules/infra/i18n';
import Layout from '../components/Layout';
import PieChart from '../components/PieChart';
import PieChartLegend from '../components/PieChartLegend';
import BarberFilter from '../metrics/barberFilterContainer';
import SalesByBarberFilters from '../filters/containers/Filters';
import DirtyFilterOverlay from '../components/DirtyFilterOverlay';

const BarberSalesSummary = ({
  topGrossing,
  averagePricePerService,
  servicesBooked,
  productsSold,
  noShows,
  cancellations,
  discounts,
  tips,
  fetcher,
}) => (
  <Layout title={t('reports:barber_sales_summary.title')}>
    <div className="c-sales-by-barber-wrapper">
      <div className="c-report-filters u-mb-">
        <div className="u-mr0 large-and-up-mr- u-mb">
          <SalesByBarberFilters
            showCsvExport={false}
            disableBarberFilter
            fetcher={fetcher}
          >
            <div className="c-report-filters__item">
              <BarberFilter />
            </div>
          </SalesByBarberFilters>
        </div>
      </div>
      <div className="layout u-position-relative">
        <DirtyFilterOverlay />
        <div className="layout__item u-1/2-extralarge-and-up">
          <div className="c-heading--small u-co-primary u-type--bold u-type--uppercase u-mb-">{t('reports:barber_sales_summary.net_sales')}</div>
          <div className="c-report-panel c-report-panel--small c-report-panel--offset u-pb-">
            <div className="c-chart-grid-right">
              <div>
                <PieChartLegend data={topGrossing} automationId="netSales" />
              </div>
              <div className="c-chart-grid-right__pie-chart">
                <PieChart data={topGrossing} />
              </div>
            </div>
          </div>
        </div>
        <div className="layout__item u-1/2-extralarge-and-up">
          <div className="c-heading--small u-co-primary u-type--bold u-type--uppercase u-mb-">
            {t('reports:barber_sales_summary.average_price_per_service')}
          </div>
          <div className="c-report-panel c-report-panel--small c-report-panel--offset u-pb-">
            <div className="c-chart-grid-right">
              <div>
                <PieChartLegend data={averagePricePerService} automationId="averagePricePerService" />
              </div>
              <div className="c-chart-grid-right__pie-chart">
                <PieChart data={averagePricePerService} />
              </div>
            </div>
          </div>
        </div>
        <div className="layout__item u-1/2-extralarge-and-up">
          <div className="c-heading--small u-co-primary u-type--bold u-type--uppercase u-mb-">{t('reports:barber_sales_summary.services_performed')}</div>
          <div className="c-report-panel c-report-panel--small c-report-panel--offset u-pb-">
            <div className="c-chart-grid-right">
              <div>
                <PieChartLegend data={servicesBooked} automationId="servicesBooked" />
              </div>
              <div className="c-chart-grid-right__pie-chart">
                <PieChart data={servicesBooked} />
              </div>
            </div>
          </div>
        </div>
        <div className="layout__item u-1/2-extralarge-and-up">
          <div className="c-heading--small u-co-primary u-type--bold u-type--uppercase u-mb-">{t('reports:barber_sales_summary.products_sold')}</div>
          <div className="c-report-panel c-report-panel--small c-report-panel--offset u-pb-">
            <div className="c-chart-grid-right">
              <div>
                <PieChartLegend data={productsSold} automationId="productsSold" />
              </div>
              <div className="c-chart-grid-right__pie-chart">
                <PieChart data={productsSold} />
              </div>
            </div>
          </div>
        </div>
        <div className="layout__item u-1/2-extralarge-and-up">
          <div className="c-heading--small u-co-primary u-type--bold u-type--uppercase u-mb-">{t('reports:barber_sales_summary.discounts')}</div>
          <div className="c-report-panel c-report-panel--small c-report-panel--offset u-pb-">
            <div className="c-chart-grid-right">
              <div>
                <PieChartLegend data={discounts} automationId="discounts" />
              </div>
              <div className="c-chart-grid-right__pie-chart">
                <PieChart data={discounts} />
              </div>
            </div>
          </div>
        </div>
        <div className="layout__item u-1/2-extralarge-and-up">
          <div className="c-heading--small u-co-primary u-type--bold u-type--uppercase u-mb-">{t('reports:barber_sales_summary.tips')}</div>
          <div className="c-report-panel c-report-panel--small c-report-panel--offset u-pb-">
            <div className="c-chart-grid-right">
              <div>
                <PieChartLegend data={tips} automationId="tips" />
              </div>
              <div className="c-chart-grid-right__pie-chart">
                <PieChart data={tips} />
              </div>
            </div>
          </div>
        </div>
        <div className="layout__item u-1/2-extralarge-and-up">
          <div className="c-heading--small u-co-primary u-type--bold u-type--uppercase u-mb-">{t('reports:barber_sales_summary.no_shows')}</div>
          <div className="c-report-panel c-report-panel--small c-report-panel--offset u-pb-">
            <div className="c-chart-grid-right">
              <div>
                <PieChartLegend data={noShows} automationId="noShows" />
              </div>
              <div className="c-chart-grid-right__pie-chart">
                <PieChart data={noShows} />
              </div>
            </div>
          </div>
        </div>
        <div className="layout__item u-1/2-extralarge-and-up">
          <div className="c-heading--small u-co-primary u-type--bold u-type--uppercase u-mb-">{t('reports:barber_sales_summary.cancellations')}</div>
          <div className="c-report-panel c-report-panel--small c-report-panel--offset u-pb-">
            <div className="c-chart-grid-right">
              <div>
                <PieChartLegend data={cancellations} automationId="cancellations" />
              </div>
              <div className="c-chart-grid-right__pie-chart">
                <PieChart data={cancellations} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
);

BarberSalesSummary.propTypes = {
  topGrossing: PropTypes.arrayOf(PropTypes.object),
  averagePricePerService: PropTypes.arrayOf(PropTypes.object),
  servicesBooked: PropTypes.arrayOf(PropTypes.object),
  productsSold: PropTypes.arrayOf(PropTypes.object),
  noShows: PropTypes.arrayOf(PropTypes.object),
  cancellations: PropTypes.arrayOf(PropTypes.object),
  discounts: PropTypes.arrayOf(PropTypes.object),
  tips: PropTypes.arrayOf(PropTypes.object),
  fetcher: PropTypes.func.isRequired,
};

BarberSalesSummary.defaultProps = {
  topGrossing: {},
  averagePricePerService: {},
  servicesBooked: {},
  productsSold: {},
  noShows: {},
  cancellations: {},
  discounts: {},
  tips: {},
};

export default BarberSalesSummary;
